<app-load-dropdown-data [formName]="formName" 
    (fillDropdownData)="fillDropdownData()"  ></app-load-dropdown-data>
<div class="modal-header  d-flex align-items-center justify-content-center position-relative">
  <div><span class="font-semibold text-primary">{{data?.modalTitle}}</span></div>
  <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
  <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button" (click)="activeModal?.dismiss()"></app-svg-icon>
</div>
<div class="col">
  <form autocomplete="off" ngNativeValidate #FundTransferForm="ngForm">
    <div class="row px-3">
      <div class="col-12 px-0 py-2">
        <div class="row mb-2">
          <div class="col-12">
            <div class="font-semibold f-18">
              <span class="text-gray-color ">Customer Name: </span> <span class="text-pink">{{data?.formModel.invoiceModel.accountLedgerName ||''}}</span>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col gap-2 d-flex align-items-center">
            <label for="" class="f-14 w-20 font-semibold text-gray-color text-nowrap mb-0">Date</label>
            <div class="col">
              <app-input-datepicker-renderer
              [inputDate]="invoiceDate" [inputClass]="'ms-6'" (dateChanged)="selectedRangeDates($event)">
              </app-input-datepicker-renderer>
            </div>
          </div>
          <div class="col gap-2 d-flex">
            <div class="d-flex align-items-center">
              <label for="" class="f-14 font-semibold  text-gray-color text-nowrap mb-0">Extra Paid</label>
            </div>
            <div class="col">
              <app-input-with-icon 
              [notNagativeDecimalNumber]="true"
              [inputName]="'extraPaidPer'" 
              [inputType]="'extraPaidPer'"
              [inputClass]="'text-end padding_custom'"
              [isPercentApplicable] ="true"
              [inputValue]="data?.formModel?.invoiceModel?.extraPaidPer"
              (inputValueEmit)="data?.formModel.invoiceModel.extraPaidPer =$event; onExtraPaidChange($event)" 
              [isRequired]="true" 
              [isPercentIcon]="true"
              (keydown.enter)="onKeydown($event, 'extraPaidAmount')"
              >
            </app-input-with-icon>
            </div>
          </div>
          <div class="col">
            <div class="d-flex align-items-center">
              <app-input
              [decimalPlaces]="2"
              [inputName]="'extraPaidAmount'" 
              [inputType]="'text'"
              [inputId]="'extraPaidAmount'"
              [inputClass]="'text-end'"
              [inputValue]="data?.formModel?.invoiceModel?.extraPaidAmount"
              (inputValueEmit)="data?.formModel.invoiceModel.extraPaidAmount = $event; onExtraPaidAmountChange($event)" 
              (keydown.enter)="onKeydown($event, 'amount')">
              </app-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col gap-2 d-flex">
            <div class="d-flex align-items-center">
              <label for="" class="f-14 font-semibold  text-gray-color text-nowrap mb-0">Amount</label>
            </div>
            <div class="col">
              <app-input
              [decimalRestrictedDigit]="true"
              [inputName]="'amount'" 
              [inputClass]="'text-end'"
              [inputType]="'text'"
              [inputId]="'amount'"
              [inputValue]="data?.formModel?.invoiceModel?.amount?.toFixed(2)"
              [readOnly]="true"
              (inputValueEmit)="onAmountChange($event)"  
              (keydown.enter)="onKeydown($event, 'totalamt')">
              </app-input>
            </div>
          </div>
          <div class="col gap-2 d-flex">
            <div class="d-flex align-items-center">
              <label for="" class="f-14 font-semibold  text-gray-color text-nowrap mb-0"> Total Amt.</label>
            </div>
            <div class="col">
              <app-input
              [inputName]="'totalamt'" 
              [inputType]="'text'"
              [inputId]="'totalamt'"
              [inputClass]="'text-end'"
              [inputValue]="data?.formModel?.invoiceModel?.totalAmount?.toFixed(2)"
              [readOnly]="true"
              (inputValueEmit)="data?.formModel.invoiceModel.totalAmount = $event"
              (keydown.enter)="onKeydown($event, 'addfundButton')"
              >
              </app-input>
            </div>
          </div>
            <div *ngIf="data?.modalTitle=='Fund Withdraw'" class="col d-flex align-items-center justify-content-end">
              <app-button class="" [buttonLabel]="'Add'" [buttonClass]="'add_button px-2'" [buttonType]="'button'"
              [showPlusIcon]="true" [buttonId]="'addfundButton'" (buttonOutputEvent)="addDataPaymentGrid()">
            </app-button>
            </div>
        </div>
      </div>
      <hr class="my-0 border-gray-1">
      <div *ngIf="data?.modalTitle=='Fund Withdraw'" class="col-12 p-0 flex-fill mb-3">
        <app-payment-section 
        [data?.formModel] = "data?.formModel"
        [paymentSectionModel]="paymentSectionModel"
        [gridDynamicHeightClass]="'Fund_Transfer_popup'"
        [isHideMoreButton]="true"
        [bold]="true"
     ></app-payment-section>
      </div>
    </div>
    <div class="modal-footer pt-3 pb-1">
      <app-button class="my-0 me-3" (buttonOutputEvent)="activeModal.close()" [buttonLabel]="'Close'" [buttonClass]="'pink_button'" [buttonType]="'button'">
      </app-button>
      <app-button class="m-0" [buttonLabel]="'Save'" (buttonOutputEvent)="addInvoice()" [buttonClass]="'blue_button'" [buttonType]="'submit'">
      </app-button>
    </div>
  </form>
</div>